import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Switch from "../Common/Switch";
import InputText from "../sectioninput/formelement/InputText";
import _ from "lodash";
import { getProductItem, updateProduct } from "../../REDUX/actions/products";
import ProductSubmitButton from "./ProductSubmitButton";
import Uploader from "../Common/Uploader";

import { Accordion, Form } from "react-bootstrap";
import { productUrlRewrite } from "../../utils/utils";
import Lists from "../Lists/Lists";
import VehiculesSelect from "../sectioninput/formelement/VehiculesSelect";
const ProductForm = ({ productItem }) => {
  const dispatch = useDispatch();
  const [productInputs, setproductInputs] = useState(
    productItem
      ? _.omit(productItem.attributes, [
          "banner",
          "createdAt",
          "updatedAt",
          "seo",
        ])
      : {}
  );
  const handleProductChange = (value, champs) => {
    setproductInputs({ ...productInputs, [champs]: value });
  };
  const [image, setimage] = useState(productItem.attributes?.image?.data);
  // const [technicalSheet, settechnicalSheet] = useState(
  //   productItem.attributes.ficheTechnique?.data
  // );
  // const [relatedProducts, setrelatedProducts] = useState();
  const handleUpdateProduct = () => {
    dispatch(
      updateProduct(productItem?.id, {
        ...productInputs,
        image: image.id,
        list: productInputs.list.data,
      })
    );
    dispatch(getProductItem(productItem?.id));
  };
  useEffect(() => {
    setproductInputs(
      productItem
        ? _.omit(productItem.attributes, [
            "banner",
            "createdAt",
            "updatedAt",
            "seo",
          ])
        : {}
    );

    setimage(productItem.attributes.image.data);

    // eslint-disable-next-line
  }, [productItem.attributes]);

  const handleImage = (imageSelected) => {
    setimage(imageSelected);
  };
  // const handleImage2 = (imageSelected) => {
  //   setimage2(imageSelected);
  // };
  // const handleTechnicalSheet = (sheetSelected) => {
  //   settechnicalSheet(sheetSelected);
  // };

  const itemStyle = "card-body noBorder mb-4 p-0 rounded-10";
  const headerStyle = "mb-0 f24 fw-normal text-orange";

  return (
    <Accordion className=" rounded-10 mt-4 ">
      <Accordion.Item className={itemStyle} eventKey="0">
        <Accordion.Header className="d-flex align-items-center">
          <h2 className={headerStyle}>Séction Générale</h2>
        </Accordion.Header>
        <Accordion.Body>
          {/* <InputText
            labelinput='Nom du produit'
            handleChange={handleProductChange}
            champs='name'
            value={productInputs.name}
          /> */}
          {/* =================================== URL REWRITE ============================================ */}
          <VehiculesSelect
            handleProductChange={handleProductChange}
            selectedVehicle={productInputs.brand}
          />
          <InputText
            labelinput="Url"
            handleChange={handleProductChange}
            champs="path"
            value={productUrlRewrite(productItem.id, productInputs.name)}
          />
          {/* =================================== URL REWRITE ============================================ */}
          <InputText
            labelinput="name"
            handleChange={handleProductChange}
            champs="name"
            value={productInputs?.name}
          />
          <InputText
            labelinput="Prix"
            handleChange={handleProductChange}
            champs="price"
            value={productInputs?.price}
            type="number"
          />
          <InputText
            labelinput="Rent By Month"
            handleChange={handleProductChange}
            champs="rentByMonth"
            value={productInputs?.rentByMonth}
            type="number"
          />

          <div className="d-flex mt-4">
            <p className="me-2">disponibilité</p>
            <Form.Check
              className="me-2"
              type="switch"
              defaultChecked={productInputs.disponibility}
              onChange={(e) =>
                setproductInputs({
                  ...productInputs,
                  disponibility: e.target.checked,
                })
              }
            />
          </div>
          <InputText
            labelinput="Motorization"
            handleChange={handleProductChange}
            champs="motorization"
            value={productInputs?.motorization}
          />
          <InputText
            labelinput="autonomy"
            handleChange={handleProductChange}
            champs="autonomy"
            value={productInputs?.autonomy}
            type="number"
          />
          <InputText
            labelinput="Couleur"
            handleChange={handleProductChange}
            champs="color"
            value={productInputs?.color}
          />
          <InputText
            labelinput="engine"
            handleChange={handleProductChange}
            champs="engine"
            value={productInputs?.engine}
          />
          <InputText
            labelinput="gearBox"
            handleChange={handleProductChange}
            champs="gearBox"
            value={productInputs?.gearBox}
          />
          <InputText
            labelinput="rims"
            handleChange={handleProductChange}
            champs="rims"
            value={productInputs?.rims}
          />
          <InputText
            labelinput="Vitesse par KM"
            handleChange={handleProductChange}
            champs="speedByKm"
            value={productInputs?.speedByKm}
            type="number"
          />
          <InputText
            labelinput="Description"
            textArea
            handleChange={handleProductChange}
            champs="description"
            value={productInputs?.description}
          />
          <InputText
            labelinput="max speed"
            handleChange={handleProductChange}
            champs="maxSpeed"
            value={productInputs?.maxSpeed}
            type="number"
          />
          <InputText
            labelinput="release"
            handleChange={handleProductChange}
            champs="release"
            value={productInputs?.release}
            type="date"
          />
          <InputText
            labelinput="odometer"
            handleChange={handleProductChange}
            champs="odometer"
            value={productInputs?.odometer}
            type="number"
          />
          <InputText
            labelinput="conduct"
            handleChange={handleProductChange}
            champs="conduct"
            value={productInputs?.conduct}
          />
          {productInputs.showCarousel ? (
            <div className="w-40">
              <InputText
                labelinput="Ordre d'affichage dans la carousel"
                type="number"
                handleChange={handleProductChange}
                champs="order"
                value={productInputs?.order}
              />
            </div>
          ) : null}
          {/* <Switch label="En Stock" values={availability} handleChange={handleProductChange} champs="onstock" value={productInputs.onstock} required /> */}
          <ProductSubmitButton
            handleUpdateProduct={handleUpdateProduct}
            productInputs={productInputs}
          />
        </Accordion.Body>
      </Accordion.Item>
      {/* <Accordion.Item className={itemStyle} eventKey="1">
        <Accordion.Header>
          <h2 className={headerStyle}>Fiche Téchnique</h2>
        </Accordion.Header>
        <Accordion.Body>
          <div className="d-flex justify-content-center">
            <div>
              <Uploader handleImage={handleTechnicalSheet} image={technicalSheet} resolution={"Pdf"} />
            </div>
          </div>

          <ProductSubmitButton handleUpdateProduct={handleUpdateProduct} productInputs={productInputs} />
        </Accordion.Body>
      </Accordion.Item> */}

      <Accordion.Item className={itemStyle} eventKey="12">
        <Accordion.Header>
          <h2 className={headerStyle}>Séction Images Principales</h2>
        </Accordion.Header>
        <Accordion.Body>
          <div className="row align-items-center">
            <div className="col">
              <div className="row align-items-center justify-content-center">
                <div className="col-4">
                  <Uploader
                    handleImage={handleImage}
                    image={image ? image : "/NotFound.png"}
                    resolution={"Image Produit"}
                  />
                </div>
                {/* {image2 && (
                  <div className="col-6">
                    <Uploader handleImage={handleImage2} image={image2} resolution={"Image Produit 3D"} />
                  </div>
                )} */}
              </div>
            </div>
          </div>
          {productInputs.list?.data && (
            <Lists
              listData={productInputs.list.data}
              magasinId={productItem.id}
            />
          )}
          <ProductSubmitButton
            handleUpdateProduct={handleUpdateProduct}
            productInputs={productInputs}
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default ProductForm;
